import { Outlet } from "@tanstack/react-router";

export function App() {
  return <Outlet />;
}

export default App;
